import { reactive } from 'vue';

const statuses = reactive<Record<string, RequestStatus>>({});

export default function useRequestStatus() {
  const set = (id, status: RequestStatus) => {
    statuses[id] = status;
  };

  return { statuses, set };
}
